import { render, staticRenderFns } from "./historyTable.vue?vue&type=template&id=1f9b9432&"
import script from "./historyTable.vue?vue&type=script&lang=js&"
export * from "./historyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9b9432')) {
      api.createRecord('1f9b9432', component.options)
    } else {
      api.reload('1f9b9432', component.options)
    }
    module.hot.accept("./historyTable.vue?vue&type=template&id=1f9b9432&", function () {
      api.rerender('1f9b9432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/components/historyTable.vue"
export default component.exports